import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const GMPe = lazy(() => import("./GMPParent"));

const GMP_ROUTES: RouteObject[] = [
    {
      path: "/private/data-audit",
      element: React.createElement(GMPe),
    },
    {
      path: "/private/gmp/:parentModuleOptionTitle", 
      element: React.createElement(GMPe),
    },
];

export default GMP_ROUTES;
